import { t } from "@lingui/macro";
import { DataTable, Spinner } from "@src/components/ui-kit";
import { Pagination } from "@src/components/ui-kit/table/pagination";
import { FiltersPanel } from "@src/utils/components/filters/components/filters-panel";
import { withCan } from "@src/utils/components/permissions";
import { useStore, useUpdateURI } from "@src/utils/hooks";
import { getQueryParamOptional } from "@src/utils/routing";
import { getParamFromQuery } from "@src/utils/url";
import { observer } from "mobx-react-lite";
import { useRouter } from "next/router";
import { useMemo } from "react";
import { LastMonthNotClosed } from "./Banner";
import { useFetchFilterOptions, useFetchTableData } from "./hooks";
import NavBar from "./NavBar";
import { Store, StoreContext } from "./Store";
import { SummaryBox } from "./SummaryBox";
import { Table } from "./Table";

const ListWip = () => {
  const { query } = useRouter();
  const appStore = useStore();

  const store = useMemo(() => {
    const store = new Store(appStore);

    store.searchTerm = getParamFromQuery("search", query) ?? "";
    store.where.fromURLSearchParam(query);
    store.orderBy.fromURLSearchParam(query);
    store.pagination.fromURLSearchParam(query);
    store.wipPeriodsStore.setPeriodId(getQueryParamOptional("period", query));

    return store;
  }, []);

  useUpdateURI(store.searchParams);

  useFetchFilterOptions(store);

  const { loading, loadingSummary } = useFetchTableData(store);

  return (
    <StoreContext.Provider value={store}>
      {store.summary?.is_previous_period_closed === false && (
        <LastMonthNotClosed />
      )}

      {loading && <Spinner absolute />}

      <DataTable>
        <NavBar />
        <DataTable.Filter>
          <FiltersPanel
            filters={store.where}
            searchPlaceholder={t`Search by title, code, brand`}
            searchDefaultValue={store.searchTerm}
            onSearch={(val) => {
              store.searchTerm = val;
              store.pagination.resetPage();
            }}
          />
        </DataTable.Filter>
        <SummaryBox
          isLoaded={!loadingSummary}
          period={store.wipPeriodsStore.currentPeriod}
          summary={store.summary}
        />
        <Table data={store.projectsWip} orderBy={store.orderBy} />
        <Pagination store={store.pagination} />
      </DataTable>
    </StoreContext.Provider>
  );
};

export default withCan(
  { do: ["wip_read_all", "wip_read_team", "wip_read_own"] },
  observer(ListWip),
);
